import React from 'react'

import {
  Body2,
  Bold,
  Box,
  Display,
  Heading2,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

import { LandingPageButton, TwoColumnLayout } from '../../components'
import { HowGoustoFoodBoxesWorkSections, TargetUri, TrackingActions } from '../../types/tracking'
import goustbox from '../assets/goustobox.jpg'
import { FOOD_BOX } from './config'

import type { HowGoustoFoodBoxesWorkTypes } from '../../types'

export function FoodBoxSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <TwoColumnLayout image={{ src: goustbox, alt: FOOD_BOX.altText }}>
      <Heading2>{FOOD_BOX.headingLine1}</Heading2>
      <Space size={3} />
      <Body2 size={4}>
        A Gousto food box is your shortcut to delicious, home-cooked meals - without the stress.
      </Body2>
      <Space size={6} />
      <Body2 size={4}>
        Each box comes packed with perfectly <Bold>portioned ingredients</Bold> and{' '}
        <Bold>easy step-by-step recipe cards.</Bold> That means no last-minute supermarket dashes,
        no measuring, and no wondering what&apos;s for dinner. Just{' '}
        <Bold>pick your recipes and we&apos;ll do the rest</Bold>, no matter the size of the
        household.
      </Body2>
      <Space size={6} />
      <Box
        display={Display.Flex}
        justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
      >
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={HowGoustoFoodBoxesWorkSections.FOOD_BOX_SECTION}
          target={TargetUri.SIGNUP}
          action={TrackingActions.CLICK_GET_STARTED}
        >
          {FOOD_BOX.ctaText}
        </LandingPageButton>
      </Box>
    </TwoColumnLayout>
  )
}
